module.exports = __webpack_public_path__ + "img/avatar-7.8424367e.png";